module.exports = __webpack_public_path__ + "okticon.5e1f49dda77e01218444c76678856d3d.ttf";